import { loadRuntimeConfig, runtimeConfig } from './config/runtime';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import './css/controls.css'

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
async function bootstrap() {
  try {
    await loadRuntimeConfig();
		const settings = runtimeConfig();
		const showApp = async () => {
			const { default: App } = await import('./App');
			root.render(<React.StrictMode><App /></React.StrictMode>);
		};
		if (settings.IS_CLIENT && settings.SETUP_ONLY) {
			const { default: Setup } = await import('./pages/LicenseSetup');
			root.render(<React.StrictMode><Setup /></React.StrictMode>);
		} else if (settings.IS_CLIENT && !['/sso', '/invite', '/reg', '/forgot', '/reset'].includes(window.location.pathname)) {
			// Do not initialize normal authentication stores while first-run setup
			// is visible. Go to login always bypasses this convenience landing.
			const { ClientStartup } = await import('./pages/LicenseSetup');
			root.render(<React.StrictMode><ClientStartup onReady={showApp} /></React.StrictMode>);
		} else await showApp();
  } catch (_) {
    root.render(<main role="alert" style={{ padding: '2rem' }}>Unable to load application settings. Contact your administrator.</main>);
  }
}
void bootstrap();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
